import { isEmpty, isNil } from 'lodash'
import { makaluApi } from '@/shared/utils/makaluApiClient'

const DEFAULT_FILE_NAME = 'downloaded-file'

const toFileName = (contentDisposition: string | null): string =>
    contentDisposition?.includes('filename=')
        ? (contentDisposition.split('filename=')[1]?.replace(/["']/g, '') ?? DEFAULT_FILE_NAME)
        : DEFAULT_FILE_NAME

const downloadFile = async (companyId: string, fileId: string): Promise<File | null> => {
    const { data, response } = await makaluApi.GETWithResponse('/companies/{companyId}/download/{fileId}', {
        params: { path: { companyId, fileId } },
        headers: { Accept: 'application/octet-stream', 'Content-Type': 'application/octet-stream' },
        parseAs: 'blob'
    })
    if (!data) return null

    return new File([data], toFileName(response.headers.get('content-disposition')), {
        type: data.type || 'application/octet-stream'
    })
}

// One failed download fails them all, so the view shows an error instead of a partial list.
export const downloadFiles = async (companyId: string, fileIds: string[] | null | undefined): Promise<File[]> => {
    if (isNil(fileIds) || isEmpty(fileIds)) return []

    const files = await Promise.all(fileIds.map((fileId) => downloadFile(companyId, fileId)))

    return files.filter((file): file is File => file !== null)
}
